export default __webpack_public_path__ + "static/23609_3-353x230-c308cc35b9a44c481f3a04108b3eb1c7.jpg";